import { Waypoint } from 'react-waypoint';

import { Button, HeroLayout, Image, Text } from '@change/ds-core-ui/next';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import { useContributeSection } from './hooks/useContributeSection';

export function ContributeSectionSunrise() {
	const { translate } = useI18n();
	const {
		actions: { onCtaClick, onSectionView },
	} = useContributeSection();

	return (
		<HeroLayout
			variant="1/2"
			data-testid="homepage-sunrise-contribute-section"
			reverseMd
			className="text-typography-strong bg-background-raised"
			media={
				<Image
					alt={translate('corgi.homepage.contribute_section.image.alt_text')}
					src="https://static.change.org/homepageV3/homepage-sunrise-contribute@1x.png"
					srcSet="https://static.change.org/homepageV3/homepage-sunrise-contribute@1x.png 1x, https://static.change.org/homepageV3/homepage-sunrise-contribute@2x.png 2x, https://static.change.org/homepageV3/homepage-sunrise-contribute@3x.png 3x,"
					className="bg-background-raised min-h-full object-cover md:min-w-full"
				/>
			}
		>
			<div className="flex flex-col items-start gap-6 p-8 md:p-12">
				<div>
					<Waypoint onEnter={onSectionView} />
					<Text as="h2" data-qa="contribute-section-title" variant="heading" size="large">
						<Translate value="corgi.homepage.contribute_section.title" />
						<br />
						<Translate value="corgi.homepage.contribute_section.subtitle" />
					</Text>
				</div>
				<Text variant="body">
					<Translate value="corgi.homepage.contribute_section.description" />
				</Text>

				<Button data-qa="homepage-contribute-section-cta" onClick={onCtaClick} as="a" href="/member/join">
					<Translate value="corgi.homepage.contribute_section.cta_btn" />
				</Button>
			</div>
		</HeroLayout>
	);
}
